var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.forms
      ? _c("div", { staticClass: "tls-popup--body-slot tls-selection-new" }, [
          _c("div", { staticClass: "tls-popup-line" }),
          _vm._v(" "),
          _c("div", { staticClass: "tls-field" }, [
            _c(
              "div",
              [
                _c("div", { staticClass: "tls-input-check-group" }, [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checked,
                          expression: "checked"
                        }
                      ],
                      attrs: { type: "checkbox", name: "rb" },
                      domProps: {
                        checked: Array.isArray(_vm.checked)
                          ? _vm._i(_vm.checked, null) > -1
                          : _vm.checked
                      },
                      on: {
                        click: _vm.selectAll,
                        change: function($event) {
                          var $$a = _vm.checked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.checked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.checked = $$c
                          }
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "tls-input-check--label" }, [
                    _vm._v(_vm._s(_vm._.get(_vm.keywords, "select_all")))
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.forms, function(form) {
                  return _c("div", { staticClass: "tls-input-check-group" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedForms,
                            expression: "selectedForms"
                          }
                        ],
                        attrs: { id: form.f_id, type: "checkbox", name: "cb" },
                        domProps: {
                          value: form,
                          checked: Array.isArray(_vm.selectedForms)
                            ? _vm._i(_vm.selectedForms, form) > -1
                            : _vm.selectedForms
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.selectedForms,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = form,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.selectedForms = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectedForms = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectedForms = $$c
                              }
                            },
                            function($event) {
                              return _vm.changeForms(_vm.selectedForms)
                            }
                          ]
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "tls-input-check--label",
                        attrs: { for: form.f_id }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              form.f_pers_surnames +
                                " " +
                                form.f_pers_givennames
                            ) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "tls-button-primary -uppercase",
              attrs: { disabled: _vm.selectedForms.length === 0 },
              on: { click: _vm.confirm }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._.get(_vm.keywords, "confirm")) +
                  "\n        "
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }